import React, { useContext, useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import InicioSesion from './InicioSesion';
import Quote from './Quote';
import SearchBar from './HeaderComponents/SearchBar';
import CartDropdown from './HeaderComponents/CartDropdown';
import { UserAuthContext } from '../../UserAuthContext';
import LogoutLogo from '../../assets/images/Logout.png';
import ValleyLogo from '../../assets/images/logo-valley.webp';
import { useLanguage } from '../../LanguageContext';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useContext(UserAuthContext);
  const { t } = useLanguage();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const handleInStockClick = (event) => {
    event.preventDefault();
    setMenuOpen(false);

    if (location.pathname === '/') {
      document.getElementById('InStockBrands')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      return;
    }

    navigate('/#InStockBrands');
  };

  const mainLinks = (
    <>
      <NavLink to="/" end>{t('Home', 'Inicio')}</NavLink>
      <a href="/#InStockBrands" onClick={handleInStockClick}>{t('In stock', 'En existencia')}</a>
      <NavLink to="/brands">{t('Brands', 'Marcas')}</NavLink>
      <NavLink to="/about">{t('Company', 'Empresa')}</NavLink>
      <a href="/insights">{t('Insights', 'Contenido')}</a>
      {user && <NavLink to="/orders">{t('My orders', 'Mis pedidos')}</NavLink>}
    </>
  );

  return (
    <header className="vs-header">
      <div className="vs-utility">
        <div className="vs-header-container vs-utility-inner">
          <p>
            <span className="vs-status-dot" />
            {t('Sourcing industrial automation across the world', 'Abastecimiento de automatización industrial en todo el mundo')}
          </p>
          <div className="vs-utility-links">
            <a href="mailto:inquiry@valleyintlsupply.com">
              <i className="fas fa-envelope" aria-hidden="true" />
              inquiry@valleyintlsupply.com
            </a>
            <a href="tel:+19563380631">
              <i className="fas fa-phone-alt" aria-hidden="true" />
              +1 956-338-0631
            </a>
          </div>
        </div>
      </div>

      <div className="vs-mainbar">
        <div className="vs-header-container vs-mainbar-inner">
          <Link to="/" className="vs-logo-link" aria-label={t('Valley International Supply home', 'Inicio de Valley International Supply')}>
            <img src={ValleyLogo} alt="Valley International Supply" />
          </Link>

          <nav className="vs-desktop-nav" aria-label={t('Main navigation', 'Navegación principal')}>
            {mainLinks}
          </nav>

          <div className="vs-header-actions">
            <div className="vs-search-wrap">
              <SearchBar />
            </div>
            <div className="vs-commerce-actions">
              <CartDropdown />
              <Quote />
              {user ? (
                <div className="vs-user-control">
                  <Link to="/orders" title={t('View your orders', 'Ver sus pedidos')}>{t('Hi', 'Hola')}, {user.name?.split(' ')[0]}</Link>
                  <button onClick={logout} type="button" aria-label={t('Log out', 'Cerrar sesión')}>
                    <img src={LogoutLogo} alt="" />
                  </button>
                </div>
              ) : (
                <InicioSesion />
              )}
            </div>
            <button
              className={`vs-menu-toggle ${menuOpen ? 'is-open' : ''}`}
              type="button"
              aria-expanded={menuOpen}
              aria-controls="vs-mobile-menu"
              aria-label={menuOpen ? t('Close menu', 'Cerrar menú') : t('Open menu', 'Abrir menú')}
              onClick={() => setMenuOpen((open) => !open)}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </div>

      <div id="vs-mobile-menu" className={`vs-mobile-panel ${menuOpen ? 'is-open' : ''}`}>
        <div className="vs-mobile-search">
          <SearchBar />
        </div>
        <nav aria-label={t('Mobile navigation', 'Navegación móvil')}>{mainLinks}</nav>
        <div className="vs-mobile-contact">
          <span>{t('Need help finding a part?', '¿Necesita ayuda para encontrar una pieza?')}</span>
          <Link to="/about#contact">{t('Talk to a specialist', 'Hable con un especialista')} <b>→</b></Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
